import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getOptionWarehouse() {
    return client.get("api/options/warehouse");
}

function getOptionWarehouseAll() {
    return client.get("api/options/warehouse-all");
}

function getOptionType() {
    return client.get("api/options/user-type");
}

function getOptionProvince() {
    return client.get("api/options/area-province");
}

function getOptionCity(params) {
    return client.get("api/options/area-city", {
        params: params,
    });
}

function getOptionSubdistrict(params) {
    return client.get("api/options/area-subdistrict", {
        params: params,
    });
}

function getOptionWarehouseArea(params) {
    return client.get("api/options/warehouse-area", {
        params: params,
    });
}

function getOptionProduct() {
    return client.get("api/options/product");
}

function getOptionProductSRE() {
    return client.get("api/options/product-sre");
}

function getOptionSREforApprove() {
  return client.get("api/options/sre-for-approve/");
}

function getOptionOpnameforApprove() {
  return client.get("api/options/opname-for-approve/");
}

function getOptionProductToSell() {
    return client.get("api/options/product-to-sell");
}

function getOptionProductMain() {
    return client.get("api/options/product-main");
}

function getOptionSupplier() {
    return client.get("api/options/supplier");
}

function getOptionPaymentMethod() {
    return client.get("api/options/payment-method");
}

function getOptionTOforApprove(params) {
    return client.get("api/options/to-for-approve/" + params);
}

function getOptionTOforTDO() {
    return client.get("api/options/to-for-tdo");
}

function getOptionTDOforReceive() {
    return client.get("api/options/tdo-for-receive");
}

function getOptionPOforApprove() {
    return client.get("api/options/po-for-approve");
}

function getOptionSOforApprove() {
    return client.get("api/options/so-for-approve");
}

function getOptionSoforPay() {
    return client.get("api/options/so-for-pay");
}

function getOptionFreeTools() {
    return client.get("api/options/free-tools");
}

function getOptionPDOforAccept() {
    return client.get("api/options/pdo-for-accept");
}

function getSupplierProducts (params) {
    return client.get("api/options/product-by-supplier", {
        params: params,
    });
}

function getRegistrationRequirements (params) {
    return client.get("api/options/registration-requierements", {
        params: params,
    });
}

function getProductAvailableToRecall (params) {
	return client.get("api/options/product-available-to-recall", {
		params: params,
	});
}

function getOptionProductToAdjust() {
    return client.get("api/options/product-to-adjust");
}

function getOptionProductToReturn() {
    return client.get("api/options/product-to-return");
}

function getSupplierProductsReturn (params) {
    return client.get("api/options/product-by-supplier-return", {
        params: params,
    });
}

export default {
    getOptionProvince,
    getOptionWarehouse,
    getOptionWarehouseAll,
    getOptionType,
    getOptionCity,
    getOptionSubdistrict,
    getOptionWarehouseArea,
    getOptionProduct,
    getOptionProductSRE,
    getOptionSREforApprove,
    getOptionOpnameforApprove,
    getOptionProductMain,
    getOptionProductToSell,
    getOptionSupplier,
    getOptionPaymentMethod,
    getOptionTOforApprove,
    getOptionTOforTDO,
    getOptionTDOforReceive,
    getOptionPOforApprove,
    getOptionSOforApprove,
    getOptionSoforPay,
    getOptionFreeTools,
    getOptionPDOforAccept,
    getSupplierProducts,
    getRegistrationRequirements,
    getProductAvailableToRecall,
    getOptionProductToAdjust,
    getOptionProductToReturn,
    getSupplierProductsReturn
};
